module.exports = __webpack_public_path__ + "img/color-dynamics-1_jp.05b17ad.jpg";